import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';
import { Button } from 'ds/components/button';
import { SpacingScale } from 'ds/theme/spacing';

export const DeveloperInfoWrapper = styled.div`
  width: 100%;
  & > div {
    display: flex;
    justify-content: center;
    text-align: center;
  }
`;

export const Root = styled.div<{ sidePaddingSpacing?: SpacingScale; }>(({ theme, sidePaddingSpacing }) => ({
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  padding: theme.spacing(4, sidePaddingSpacing || 3),
  flexDirection: 'column',
  gap: theme.spacing(3),
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.neutrals.grey6}`,
  boxShadow: theme.shadow.level8,
  backgroundColor: theme.colors.brand.lightBlue,
  marginBottom: theme.spacing(2),
  [theme.media.createObjectMediaQuery({ from: 3 })]: {
    '.terms-line': {
      maxWidth: '263px',
      textAlign: 'center',
    },
  },
}));

export const FormTitle = styled(H3.withComponent('div'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const HintTitle = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
}));

export const InfoBox = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.neutrals.grey11,
  borderRadius: theme.borderRadius.small,
  padding: theme.spacing(2, 0),
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(1.5),
}));

export const UserName = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const PhoneButton = styled(Button.withComponent('a'))(({ theme }) => ({
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  svg: {
    marginLeft: theme.spacing(1),
  },
}));

export const FormBody = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  input: {
    height: theme.spacing(6),
  },
}));

export const SubmitButton = styled.div(({ theme }) => ({
  borderRadius: theme.borderRadius.round,
  backgroundColor: theme.colors.neutrals.white,
  border: `1px solid ${theme.colors.neutrals.grey6}`,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '48px',
  height: '48px',
}));


